import TransactionsApi from '@/api/transactions';

export default {
  namespaced: true,
  state: {
    transactions: [],
    payments: [],
  },
  mutations: {
    SET_TRANSACTIONS(state, val) {
      state.transactions = val;
    },
    SET_PAYMENTS(state, val) {
      state.payments = val;
    },
  },
  actions: {
    async getAllTransactions({ commit }) {
      try {
        const transactions = await TransactionsApi.getTransactions();
        commit('SET_TRANSACTIONS', transactions.data);
      } catch (e) {
        console.log(e);
      }
    },
    async getAllPayments({ commit }) {
      try {
        const payments = await TransactionsApi.getLessonsPayments();
        commit('SET_PAYMENTS', payments.data);
      } catch (e) {
        console.log(e);
      }
    },
  },
};
